import React, { useState, useEffect } from 'react';
import { API } from '../../../../API/API';
import { message } from 'antd';
import Warning from '../../../../components/Warning/Warning';
import TextTitle from '../../../../components/TextTitle/TextTitle';
import ButtonDefault from '../../../../components/ButtonDefault/ButtonDefault';
import FieldText from '../../../../components/FieldText/FieldText';
import { MessageConst } from '../../../../const/MessageConst';
import { Row, Col } from 'antd';
import { useParams } from 'react-router-dom';
import LoadSpin from '../../../../components/LoadSpin/LoadSpin';
import FieldItemList from '../../../../components/FieldItemList/FieldItemList';
import ButtonSecondary from '../../../../components/ButtonSecondary/ButtonSecondary';

const BankAccount = (props) => {

    const params = useParams();
    const [empid, setEmpId] = useState(-1);
    const [initData, setInitData] = useState({});
    const [checkRule, setCheckRule] = useState(false);
    const [data, setData] = useState({ ...initData });
    const [warning, setWarning] = useState();
    const [mode, setMode] = useState(false);
    const [colSpan] = useState(window.innerWidth > 1000 ? 8 : 24);
    const [loadingSave, setLoadingSave] = useState(false);

    useEffect(() => {
        let tEmpId = -1;
        if (params.empid) {
            tEmpId = params.empid;
        }
        setInitData({
            "empid": tEmpId,
            "bankid": null,
            "bankname": null,
            "accountno": null,
            "accountname": null
        });
        setEmpId(tEmpId);
    }, [params]);

    const getExistsData = async () => {
        let tData = { ...initData };
        tData.empid = empid;

        if (empid > 0) {
            await API.get('/api/humanresource/employee/bankaccount?empid=' + empid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
        }
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [empid]);

    const fieldOnChanged = (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname)
                tData[fieldname] = text;
            setData(tData);
            setMode(true);
        }
    }

    const onSave = async () => {
        let isValid = true;
        setCheckRule(true);

        if (!data.bankid) {
            isValid = false;
            setWarning("Банкны нэр" + MessageConst.fieldRequired);
        } else if (!data.accountno) {
            isValid = false;
            setWarning("Дансны дугаар" + MessageConst.fieldRequired);
        } else if (!data.accountname) {
            isValid = false;
            setWarning("Дансны нэр" + MessageConst.fieldRequired);
        }

        if (isValid) {
            setLoadingSave(true);

            await API.post('/api/humanresource/employee/bankaccount', data).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setMode(false);
                    getExistsData();
                    setWarning();
                }
            }).catch(response => {
                setLoadingSave(false);
            });
            setLoadingSave(false);
        }
    }

    const onDelete = async () => {
        setLoadingSave(true);
        await API.delete('/api/humanresource/employee/bankaccount?entryid=' + data.entryid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                setMode(false);
                setCheckRule(false);
                setData({ ...initData });
                setWarning();
            }
        }).catch(response => {
            setLoadingSave(false);
        });
        setLoadingSave(false);
    }

    return (
        <div style={{ padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <TextTitle title="Банкны данс" />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <Warning zeroMargin value={warning} />
                    </div>
                    {data?.entryid > 0 && (<div style={{ marginLeft: 16 }}>
                        {!loadingSave && (
                            <ButtonSecondary onClick={onDelete} text="Устгах" />
                        )}
                    </div>)}
                    {mode && (
                        <div style={{ marginLeft: 16 }}>
                            {loadingSave ? (
                                <LoadSpin />
                            ) : (
                                <ButtonDefault onClick={onSave} text="Хадгалах" />
                            )}
                        </div>
                    )}
                </div>
            </div>
            <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                <Col span={colSpan}>
                    <FieldItemList required
                        title="Банкны нэр"
                        onChanged={fieldOnChanged}
                        keyfield='bankid'
                        keyfieldname='bankname'
                        defaultValue={[{ key: data.bankid, name: data.bankname }]}
                        dataurl="/api/humanresource/employee/bankaccount/get_bank_dropdown"
                        checkreq={checkRule} />
                </Col>
                <Col span={colSpan}>
                    <FieldText required title="Дансны дугаар" onChanged={fieldOnChanged} keyfield='accountno' defaultValue={data.accountno} checkreq={checkRule} />
                </Col>
                <Col span={colSpan}>
                    <FieldText required title="Дансны нэр" onChanged={fieldOnChanged} keyfield='accountname' defaultValue={data.accountname} checkreq={checkRule} />
                </Col>
            </Row>
        </div>
    );
}

export default BankAccount;